import { editEncounterIntakeQuestions } from "../api/Encounter";
import { getSignature } from "../../Zoom/functions";

export async function reopenInProgressAppointment({
  encounter,
  practitionerId,
  practitionerName,
  practitionerUniqueId,
  navigate,
}) {
  if (!encounter?.id) throw new Error("The linked encounter is unavailable.");
  const patientId = encounter.subject?.reference?.split("/")?.[1];
  const patientName = encounter.subject?.display;
  const session = {
    encounterId: encounter.id,
    patientId,
    patientName,
    practitionerId,
    practitionerName,
    practitionerUniqueId,
    intakeQuestions: encounter.intakeQuestions,
    period: encounter.period,
    requestedPeriod: encounter.period,
    previousStatus: "in-progress-appointment",
    launchedFrom: "appointment",
  };

  if (encounter.intakeQuestions?.preferredChannel === "video/chat") {
    const topic = encounter.intakeQuestions?.zoomTopic || (encounter.appointmentId ? `appt-${encounter.appointmentId}` : `appt-${encounter.id}`);
    const password = encounter.intakeQuestions?.zoomPassword || crypto.randomUUID().replace(/-/g, "");
    if (!encounter.intakeQuestions?.zoomPassword) {
      await editEncounterIntakeQuestions({
        encounterId: encounter.id,
        payload: { intakeQuestions: { ...encounter.intakeQuestions, zoomTopic: topic, zoomPassword: password } },
      });
    }
    const signature = await getSignature({ topic, role: 1, password });
    navigate("/app/zoom-meeting-create", {
      state: { ...session, topic, password, sessionToken: signature?.data?.sessionToken },
    });
    return;
  }

  navigate("/app/interaction", {
    state: { ...session, proceedWith: "COMPLETE_CALL" },
  });
}
